import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getClientAppData } from "@/js/http/auth";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "defaultEvent",
  props: ["eventUrl"],
  components: {
    BackgroundVideo: BackgroundVideo
  },
  data: function data() {
    return {
      clientAppData: null,
      event: {
        id: null,
        eventUrl: null,
        logoUrl: null,
        firstParagraph: null,
        secondParagraphTitle: null,
        secondParagraph: null,
        leftText: null,
        leftTextLink: null,
        rightText: null,
        rightTextLink: null,
        bottomSmallerText: null,
        primaryButtonText: null,
        primaryButtonLink: null,
        footerParagraph: null
      },
      gettingEvent: {
        isPending: false,
        cancellationToken: null
      }
    };
  },
  created: function created() {
    this.clientAppData = getClientAppData(this);
    this.getEvent();
  },
  methods: {
    getEvent: function getEvent() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$gettingEvent$c;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.gettingEvent.isPending = true;
              (_this2$gettingEvent$c = _this2.gettingEvent.cancellationToken) === null || _this2$gettingEvent$c === void 0 || _this2$gettingEvent$c.cancel();
              _this2.gettingEvent.cancellationToken = axios.CancelToken.source();
              _this = _this2;
              _context.next = 6;
              return request("/v1/events/url/".concat(_this.eventUrl), "post", _this.clientAppData, false, "api", _this.gettingEvent.cancellationToken).catch(function (_) {
                _this.gettingEvent.isPending = false;
                _this.$toasted.show("Unable to get event.", {
                  type: "error"
                });
              });
            case 6:
              response = _context.sent;
              _this2.event = _objectSpread(_objectSpread({}, response.data.value), {}, {
                date: new Date().formatDateFullText()
              });
              _this2.gettingEvent.isPending = false;
              _this2.$nextTick(function () {
                _this2.gettingEvent.isPending = false;
                _this2.gettingEvent.cancellationToken = null;
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openUrl: function openUrl(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    sendMail: function sendMail(email) {
      window.location.href = "mailto:".concat(email);
    }
  }
};